import { Box, Divider, Stack } from '@mui/material'
import { Typography } from '@eventr/common-storybook'
import { parseISO, differenceInMinutes } from 'date-fns'
import { getValue } from '../../utils'
import { useFormatValue } from '../hooks/useFormatValue'
import { Icon } from '@eventr/common-storybook'
interface IFromToTimesProps {
    data: any
    renderOptions: IFromToTimesPropOptions
}
interface IFromToTimesPropOptions {
    from: string
    fromTime: string
    to: string
    toTime: string
}
export const FromToTimes = ({ data, renderOptions }: IFromToTimesProps) => {
    const { formatValue } = useFormatValue()
    const getDuration = () => {
        const diffMins = differenceInMinutes(
            parseISO(getValue(data[renderOptions.toTime])),
            parseISO(getValue(data[renderOptions.fromTime]))
        )
        const h = Math.floor(diffMins / 60)
        const m = diffMins % 60
        return `${Number.isNaN(h) ? '?' : h}h ${Number.isNaN(m) ? '?' : m}m`
    }

    return (
        <>
            {data[renderOptions.from] && (
                <Stack
                    paddingBottom="24px"
                    direction="row"
                    justifyContent="space-between"
                >
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Stack
                            marginTop="16px"
                            spacing="2px"
                            alignItems="center"
                        >
                            <Typography color="#10375C" variant="bodyBold">
                                {data[renderOptions.from]}
                            </Typography>
                        </Stack>
                    </Box>
                    <Stack marginTop="16px" alignItems="center">
                        <Icon name="Transfer" />
                    </Stack>
                    {data[renderOptions.to] && (
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Stack marginTop="16px" spacing="2px">
                                <Typography color="#10375C" variant="bodyBold">
                                    {data[renderOptions.to]}
                                </Typography>
                            </Stack>
                        </Box>
                    )}
                </Stack>
            )}
            {data[renderOptions.fromTime] && (
                <>
                    <Stack
                        margin="16px 0px 16px 0px"
                        flexDirection="row"
                        justifyContent="space-between"
                    >
                        <Typography variant="bodyBold">
                            {formatValue(
                                getValue(data[renderOptions.toTime]),
                                'time2'
                            )}
                        </Typography>
                        <Typography variant="bodyRegular">
                            {getDuration()}
                        </Typography>
                        <Typography variant="bodyBold">
                            {formatValue(
                                getValue(data[renderOptions.fromTime]),
                                'time2'
                            )}
                        </Typography>
                    </Stack>
                    <Stack marginBottom="16px">
                        <Divider />
                    </Stack>
                </>
            )}
        </>
    )
}
